module.exports = __webpack_public_path__ + "img/programme.02c8115a.svg";